
import { hasValue } from 'src/shared/NullUtil';

/**
 * In canvas, certain options (inserting links/images etc,) open in a side panel. If this is open when IF is
 * opened, it can hide the side panel and looks very confusing. So we look for the close button and close it
 * before opening IF. The container IDs have been chosen as the best option for a unique identifier as canvas
 * doesn't use id attributes on the buttons.
 */
export function closeCanvasSidePanel() {
    const canvasContainerIDs = [
        '[data-testid="CloseButton_ContentTray"]', // import media
        '[data-testid="RCELinkOptionsTray"]' // link options
    ];

    for (const containerID of canvasContainerIDs) {
        const container = document.querySelector(containerID);
        if (hasValue(container) && hasValue(container.querySelector('button'))) {
            container?.querySelector('button')?.click();
            return; // only one side panel can be open
        }
    }
}
